import { action } from "satcheljs";
import type BrowserWidthBucket from "../store/schema/BrowserWidthBucket";
import type LayoutChangeSource from "../store/schema/LayoutChangeSource";

export interface OnAvailableWidthBucketChangedActionMessage {
    availableWidthBucket: BrowserWidthBucket;
    source: LayoutChangeSource;
}
export const onAvailableWidthBucketChanged: (availableWidthBucket: BrowserWidthBucket, source: LayoutChangeSource) => OnAvailableWidthBucketChangedActionMessage = action("onAvailableWidthBucketChanged", (availableWidthBucket: BrowserWidthBucket, source: LayoutChangeSource): OnAvailableWidthBucketChangedActionMessage => ({
    availableWidthBucket,
    source,
}));
